<div class="duration-selector">
  <div class="duration-selector__title" i18n>How long would you like to study?</div>
  <lx-weeks-counter
    [min]="minWeeks()"
    [max]="maxWeeks()"
    [value]="selectedDuration()"
    (valueChanged)="onSelectDuration($event)"
    data-qa="duration-selector"
  ></lx-weeks-counter>
</div>
